<div class="relative flex w-full flex-col bg-white">
  <h2 class="mb-6 mt-6 px-4 text-3xl font-bold lg:px-8">
    {{ 'releaseNotes.headline' | transloco }}
  </h2>

  <app-update-hint />

  <p-button
    icon="pi pi-times"
    size="small"
    severity="contrast"
    class="absolute right-4 top-5"
    [attr.aria-label]="'global.close' | transloco"
    (onClick)="closeDialog()" />

  <app-scroll-container class="min-h-0 flex-1 overflow-y-auto">
    <div class="px-4 py-4 lg:px-8">
      @if (loading()) {
        <app-loading-dots />
      }

      @for (release of sortedReleaseNotes; track $index) {
        <article>
          <section>
            <markdown class="block w-full max-w-none">
              {{ release.text }}
            </markdown>
          </section>
        </article>
      }
    </div>
  </app-scroll-container>
</div>
